import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import Logger, { LOG_LEVELS } from '../../../utils/logger';
import { withFullStoryExclude } from '../../../utils/fullStoryHelper';

const log = new Logger('VAT_BOX_DETAILS_FILTER_PANEL', LOG_LEVELS.DEBUG);

export class VatBoxDetailsFilterPanel extends Component{

    constructor(props){
        super(props);
        this.onApplyClick = this.onApplyClick.bind(this);
        this.invoiceNumberChangeHandler = this.onFieldChangeHandler('invoiceNumber').bind(this);
        this.vatCodeChangeHandler = this.onFieldChangeHandler('vatCode').bind(this);

        this.state = {
            selection : {
                invoiceNumber: '', 
                vatCode: ''
            },
            applySelection: {}
        }
    }

    onFieldChangeHandler(field){
        return (evt) => {
            let selection =  Object.assign({}, this.state.selection);
            selection[field] = evt.target.value === '' ? undefined : evt.target.value;
            this.setState({
              selection: selection
            });
          };
    }

    onApplyClick() {
        let selection = Object.assign({}, this.state.selection);   
        if(typeof this.props.onApplyClick === 'function') {
            this.setState({
                applySelection: this.state.selection
            })
            this.props.onApplyClick(selection);
        }    
    }

    render() {
        log.debug('render() - props: ', this.props);
        let {selection={}, applySelection={}} = this.state;
        const disableSearch = _.isEmpty(selection.invoiceNumber) && _.isEmpty(selection.vatCode) && _.isEmpty(applySelection.invoiceNumber) && _.isEmpty(applySelection.vatCode);

        return (
            <div data-test="component-vat-box-details-filter-panel">
                <s-box name="filter-panel">
                    <fieldset>
                        <label><LanguageStringResolver string='label_vatReturn_Drilldown_Filter_InvoiceNumber'/>:</label>                           
                        <input 
                            data-test="input-invoice-number"
                            type="text" 
                            placeholder="Enter Invoice Number to search"
                            value={selection.invoiceNumber || ''}  
                            onChange={this.invoiceNumberChangeHandler}
                            />
                    </fieldset>
                    <fieldset>
                        <label><LanguageStringResolver string='label_vatReturn_Drilldown_Filter_VatCode'/>:</label>                         
                        <input 
                            className={withFullStoryExclude()}
                            data-test="input-vat-code"
                            type="text" 
                            placeholder="Enter Vat Code to search"
                            value={selection.vatCode || ''} 
                            onChange={this.vatCodeChangeHandler}
                            />
                    </fieldset>
                    <fieldset>
                        <button 
                            data-test="button-apply"
                            className={disableSearch ? 'primary disabled' : 'primary'}
                            onClick={this.onApplyClick}
                            disabled={disableSearch ? 'disabled' : ''}
                        >                             
                            <LanguageStringResolver string='label_vatReturn_Drilldown_Filter_ButtonText'/>
                        </button>                         
                    </fieldset>
                    <div className="clear"></div>
                </s-box>
            </div>
        );
    }
}


VatBoxDetailsFilterPanel.defaultProps={
    onApplyClick:()=>{}
}

function mapStateToProps(state) {
    return {
        languages: state.languages
    }
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(VatBoxDetailsFilterPanel);